import List from '@/models/List';
import { Program } from '@/models/Program';
import { ProgramCourseRequest } from '@/models/ProgramCourseRequest';
import { ProgramListStudentViewRequest } from '@/models/ProgramListStudentViewRequest';
import { ProgramRequest } from '@/models/ProgramRequest';
import { ViewType } from '@/models/ViewType';
import { AxiosError } from 'axios';
import { action } from 'typesafe-actions';
import { ProgramClassStudentView, ProgramSearchedRequest, ProgramTypes } from './types';

export const getProgramsRequest = (data: ProgramRequest) => action(ProgramTypes.GET_PROGRAMS_REQUEST, data);
export const getProgramsSuccess = (data: Program[]) => action(ProgramTypes.GET_PROGRAMS_SUCCESS, data);
export const getProgramsFailure = (error: AxiosError) => action(ProgramTypes.GET_PROGRAMS_FAILURE, error);
export const getProgramClear = () => action(ProgramTypes.GET_PROGRAM_CLEAR);

export const getProgramRequest = (programId: number) => action(ProgramTypes.GET_PROGRAM_REQUEST, programId);
export const getProgramSuccess = (data: Program) => action(ProgramTypes.GET_PROGRAM_SUCCESS, data);
export const getProgramFailure = (error: AxiosError) => action(ProgramTypes.GET_PROGRAM_FAILURE, error);

export const createProgramRequest = (data: Program) => action(ProgramTypes.CREATE_PROGRAM_REQUEST, data);
export const createProgramSuccess = (data: Program) => action(ProgramTypes.CREATE_PROGRAM_SUCCESS, data);
export const createProgramFailure = (data: AxiosError) => action(ProgramTypes.CREATE_PROGRAM_FAILURE, data);

export const updateProgramRequest = (data: Program) => action(ProgramTypes.UPDATE_PROGRAM_REQUEST, data);
export const updateProgramSuccess = () => action(ProgramTypes.UPDATE_PROGRAM_SUCCESS);
export const updateProgramFailure = (data: AxiosError) => action(ProgramTypes.UPDATE_PROGRAM_FAILURE, data);

export const reorderProgramCourseRequest = (data: ProgramCourseRequest) => action(ProgramTypes.REORDER_PROGRAM_COURSE_REQUEST, data);
export const reorderProgramCourseSuccess = () => action(ProgramTypes.REORDER_PROGRAM_COURSE_SUCCESS);
export const reorderProgramCourseFailure = (data: AxiosError) => action(ProgramTypes.REORDER_PROGRAM_COURSE_FAILURE, data);

export const createProgramCourseRequest = (data: ProgramCourseRequest) => action(ProgramTypes.CREATE_PROGRAM_COURSE_REQUEST, data);
export const createProgramCourseSuccess = (data: ProgramCourseRequest) => action(ProgramTypes.CREATE_PROGRAM_COURSE_SUCCESS, data);
export const createProgramCourseFailure = (error: AxiosError) => action(ProgramTypes.CREATE_PROGRAM_COURSE_FAILURE, error);
export const createProgramCourseClear = () => action(ProgramTypes.CREATE_PROGRAM_COURSE_CLEAR);

export const getProgramCoursesRequest = (programId: number) => action(ProgramTypes.GET_PROGRAM_COURSES_LIST_REQUEST, programId);
export const getProgramCoursesSuccess = (data: List[]) => action(ProgramTypes.GET_PROGRAM_COURSES_LIST_SUCCESS, data);
export const getProgramCoursesFailure = (data: AxiosError) => action(ProgramTypes.GET_PROGRAM_COURSES_LIST_FAILURE, data);

export const removeCourseFromProgramRequest = (programId: number, courseId: number, prerequisites: boolean) =>
    action(ProgramTypes.REMOVE_PROGRAM_COURSES_REQUEST, { programId, courseId, prerequisites });
export const removeCourseFromProgramSuccess = () => action(ProgramTypes.REMOVE_PROGRAM_COURSES_SUCCESS);
export const removeCourseFromProgramFailure = (data: AxiosError) => action(ProgramTypes.REMOVE_PROGRAM_COURSES_FAILURE, data);

export const getProgramListStudentViewRequest = (data: ProgramListStudentViewRequest) =>
    action(ProgramTypes.GET_PROGRAM_LIST_STUDENT_VIEW_REQUEST, data);

export const programsLastPublishedSuccess = (data: ProgramClassStudentView[], total: number) =>
    action(ProgramTypes.LAST_PUBLISHED_SUCCESS, { data, total });

export const programsLastPublishedClear = () => action(ProgramTypes.LAST_PUBLISHED_CLEAR);

export const programsInProgressSuccess = (data: ProgramClassStudentView[], total: number) =>
    action(ProgramTypes.IN_PROGRESS_SUCCESS, { data, total });

export const programsEssentialSuccess = (data: ProgramClassStudentView[], total: number, totalToExpire: number) =>
    action(ProgramTypes.ESSENTIALS_SUCCESS, { data, total, totalToExpire });

export const programsEssentialClear = () => action(ProgramTypes.ESSENTIALS_CLEAR);

export const programsInProgressClear = () => action(ProgramTypes.IN_PROGRESS_CLEAR);

export const getProgramListStudentViewFailure = (data: AxiosError) => action(ProgramTypes.GET_PROGRAM_LIST_STUDENT_VIEW_FAILURE, data);
export const addCourseInProgramRequest = (data: { programId: string; course: List; prerequisites: boolean }) =>
    action(ProgramTypes.ADD_COURSE_IN_PROGRAM_REQUEST, data);
export const addCourseInProgramSuccess = () => action(ProgramTypes.ADD_COURSE_IN_PROGRAM_SUCCESS);
export const addCourseInProgramFailure = (error: AxiosError) => action(ProgramTypes.ADD_COURSE_IN_PROGRAM_FAILURE, error);

export const getProgramClassStudentViewRequest = (data: ProgramListStudentViewRequest) =>
    action(ProgramTypes.GET_PROGRAM_CLASS_STUDENT_VIEW_REQUEST, data);
export const getProgramClassStudentViewSucess = (data: ProgramClassStudentView) => action(ProgramTypes.GET_PROGRAM_CLASS_STUDENT_VIEW_SUCESS, data);
export const getProgramClassStudentViewFailure = (data: AxiosError) => action(ProgramTypes.GET_PROGRAM_CLASS_STUDENT_VIEW_FAILURE, data);

export const setProgramPrerequisitesRequest = (programId: number, isEnabled: boolean) =>
    action(ProgramTypes.SET_PROGRAM_PREREQUISITES_REQUEST, { programId, isEnabled });
export const setProgramPrerequisitesSuccess = () => action(ProgramTypes.SET_PROGRAM_PREREQUISITES_SUCCESS);
export const setProgramPrerequisitesFailure = (error: AxiosError) => action(ProgramTypes.SET_PROGRAM_PREREQUISITES_FAILURE, error);

export const getProgramPrerequisitesRequest = (programId: number) => action(ProgramTypes.GET_PROGRAM_PREREQUISITES_REQUEST, programId);
export const getProgramPrerequisitesSuccess = (preRequisites: boolean) => action(ProgramTypes.GET_PROGRAM_PREREQUISITES_SUCCESS, preRequisites);
export const getProgramPrerequisitesFailure = (error: AxiosError) => action(ProgramTypes.GET_PROGRAM_PREREQUISITES_FAILURE, error);

export const publishProgramRequest = (programId: number) => action(ProgramTypes.PUBLISH_PROGRAM_REQUEST, programId);
export const publishProgramSuccess = (programId: number) => action(ProgramTypes.PUBLISH_PROGRAM_SUCCESS, programId);
export const publishProgramFailure = (error: AxiosError) => action(ProgramTypes.PUBLISH_PROGRAM_FAILURE, error);

export const clearProgramClassStudentView = () => action(ProgramTypes.CLEAR_PROGRAM_CLASS_STUDENT_VIEW);
export const programsClear = () => action(ProgramTypes.CLEAR_PROGRAM);
export const setProgramReadyRequest = (programId: number) => action(ProgramTypes.SET_PROGRAM_READY_REQUEST, programId);
export const setProgramReadySuccess = (programId: number) => action(ProgramTypes.SET_PROGRAM_READY_SUCCESS, programId);
export const setProgramReadyFailure = (error: AxiosError) => action(ProgramTypes.SET_PROGRAM_READY_FAILURE, error);

export const getProgramSearchedRequest = (data: ProgramSearchedRequest) => action(ProgramTypes.SEARCHED_REQUEST, data);
export const getProgramSearchedSuccess = (data: ProgramClassStudentView[], total: number) => action(ProgramTypes.SEARCHED_SUCCESS, { data, total });
export const getProgramSearchedFailure = (data: AxiosError) => action(ProgramTypes.SEARCHED_FAILURE, data);
export const programSearchedClear = () => action(ProgramTypes.SEARCHED_CLEAR);

export const updateProgramClassStudentViewRequest = (data: ProgramListStudentViewRequest) =>
    action(ProgramTypes.UPDATE_PROGRAM_CLASS_STUDENT_VIEW_REQUEST, data);
export const updateProgramClassStudentViewSuccess = (data: ProgramClassStudentView) =>
    action(ProgramTypes.UPDATE_PROGRAM_CLASS_STUDENT_VIEW_SUCCESS, data);
export const updateProgramClassStudentViewFailure = (data: AxiosError) => action(ProgramTypes.UPDATE_PROGRAM_CLASS_STUDENT_VIEW_FAILURE, data);
export const programsCompletedSuccess = (data: ProgramClassStudentView[], total: number) => action(ProgramTypes.COMPLETED_SUCCESS, { data, total });
export const programsCategorizedSuccess = (data: ProgramClassStudentView[], total: number, categoryId?: number) =>
    action(ProgramTypes.CATEGORIZED_SUCCESS, { data, total, categoryId });

export const addProgramByCategory = (categoryId: number) => action(ProgramTypes.ADD_PROGRAM_BY_CATEGORY, { categoryId });
export const programsCompletedClear = () => action(ProgramTypes.COMPLETED_CLEAR);
export const programsFavoriteSuccess = (data: ProgramClassStudentView[], total: number) => action(ProgramTypes.FAVORITE_SUCCESS, { data, total });
export const programsFavoriteClear = () => action(ProgramTypes.FAVORITES_CLEAR);
export const removeProgramFromList = (programId: number, viewType: ViewType) =>
    action(ProgramTypes.REMOVE_PROGRAM_FROM_LIST, { programId, viewType });

export const programsTrainingsClear = () => action(ProgramTypes.TRAININGS_CLEAR);
export const programsTrainingsSuccess = (data: ProgramClassStudentView[], total: number) => action(ProgramTypes.TRAININGS_SUCCESS, { data, total });

export const increaseProgramViewsRequest = (programId: number) => action(ProgramTypes.INCREASE_PROGRAM_VIEWS_REQUEST, programId);
export const increaseProgramViewsSuccess = () => action(ProgramTypes.INCREASE_PROGRAM_VIEWS_SUCCESS);
export const increaseProgramViewsFailure = () => action(ProgramTypes.INCREASE_PROGRAM_VIEWS_FAILURE);
